/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-return-assign */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
import differenceInYears from 'date-fns/differenceInYears';
import addDays from 'date-fns/addDays';
import { CiBank, CiWallet } from 'react-icons/ci';
import { MdOutlineCreditCard } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import {
  getInsuarnceIds,
  getInsuranceInfo,
  getUserDetails,
} from '../../api/profileApi';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import './VisaPage.scss';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import AppSelect from '../../shared/components/app-select/AppSelect';
import AppDatePicker from '../../shared/components/app-date-picker/AppDatePicker';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import AppButton from '../../shared/components/app-button/AppButton';
import AppNumberInput from '../../shared/components/app-number-input/AppNumberInput';
import {
  emailFlightOptions,
  getFlightTicketApi,
  getPaymentGateway,
  getPGCheckOutAmountApi,
} from '../../api/flightApi';
import { getUserAgentId } from '../../shared/helper-utils/localStorage';
import {
  formatDate,
  getEligibilityForPaymentMode,
  getNewDate,
  isEmpty,
  scrollToTop,
  formatCurrency,
} from '../../shared/helper-utils/appUtils';
import AppCheckBox from '../../shared/components/app-check-box/AppCheckBox';
import AppLink from '../../shared/components/app-link/AppLink';
import {
  DATE_MONTH_YEAR_WITH_HYPHEN,
  NAVIGATION_ROUTES,
  TODAY_DATE,
} from '../../shared/constants/Constants';
import AppModal from '../../shared/components/app-modal/AppModal';
import PaymentGatewayApii from '../hotels/booking-review/PaymentGatewayApii';
import {
  NET_BANKING_OPTIONS,
  NET_BANKING_OPTIONS_LIVE,
  PAYU_BANKING_OPTIONS,
  PAYU_BANKING_OPTIONS_LIVE,
} from '../../shared/constants/NetBankingOptions';

function InsurancePage() {
  const [isLoading, setIsLoading] = useState(false);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [alert, setAlert] = useState(undefined);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [planOptions, setPlanOptions] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState('');
  const [selectedPlanlabel, setSelectedPlanLabel] = useState('');
  const [depDate, setDepDate] = useState('');
  const [arrDate, setArrDate] = useState('');
  const [numDays, setNumDays] = useState('');
  const [numPax, setNumPax] = useState(1);
  const [txId, setTxId] = useState('');
  const [dob, setDob] = useState('');
  const [documentsRequired, setDocumentsRequired] = useState([]);
  const [ridesAvailable, setRidesAvailable] = useState([]);
  const [validationError, setValidationError] = useState(false);
  const selectedPaymentGatewayRef = useRef([]);
  const [selectedPg, setSelectedPg] = useState('');
  const [tempPgList, setTempPgList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paymentMode, setPaymentMode] = useState('');
  const [fareBreakup, setFareBreakup] = useState([]); // kept if used elsewhere
  const [bankId, setBankId] = useState('');
  const [selectedBankForNetBanking, setSelectedBankForNetBanking] =
    useState('');
  const [isPayuPgAccepted, setIsPayuPgAccepted] = useState(false);
  const [checkoutPgCharge, setcheckoutPgCharge] = useState(0);
  const [gstcheckoutPgCharge, setgstcheckoutPgCharge] = useState(0);
  const [checkoutInvTotal, setcheckoutInvTotal] = useState(0);
  const [errorsObj, setErrorsObj] = useState({});
  const [agent, setAgent] = useState({});
  const [paxErrorDict, setPaxErrorDict] = useState({});
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [paxDetails, setPaxDetails] = useState({
    paxname: '',
    address1: '',
    address2: '',
    district: '',
    cityName: '',
    stateName: '',
    zipCode: '',
    country: '',
    phoneNum: '',
    mobile: '',
    email: '',
    nominee: '',
    relation: '',
    passportNumber: '',
    age: '',
  });
  const [totalInvoice, setTotalInvoice] = useState(0);
  const [showFooter, setShowFooter] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [costDetails, setCostDetails] = useState({
    basecharges: 0,
    handlingcharges: 0,
    servicetax: 0,
    educess: 0,
    higheducess: 0,
    commission: 0,
    tds: 0,
    othetaxes: 0,
  });
  const [selectedRiderCodes, setSelectedRidersCode] = useState([]);
  const [riderAmount, setRiderAmount] = useState(0);
  const [isContinue, setIsContinue] = useState(false);
  const [domint, setDomint] = useState('');
  const [planBenifits, setPlanBenifits] = useState([]);
  const [showBenifitsPopup, setShowBenifitsPopup] = useState(false);
  const [hasDetails, setHasDetails] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [emailToSent, setEmailToSent] = useState('');
  const navigate = useNavigate();
  const normalizePriceDetails = (details) =>
    Object.fromEntries(
      Object.entries(details).map(([k, v]) => [
        k,
        v === '' || v == null ? 0 : Number(v),
      ]),
    );
  const handleGetPlanBenifits = async () => {
    const req = {
      actioncode: 'GETPLANBENEFITS',
      plancode: selectedPlan,
    };
    setIsLoading(true);
    try {
      const res = await getInsuranceInfo(req);
      if (
        res &&
        res.ApiStatus &&
        res.ApiStatus.Status === 'OK' &&
        !isEmpty(res.ApiStatus.Result)
      ) {
        const list = Array.isArray(res.ApiStatus.Result)
          ? res.ApiStatus.Result
          : [res.ApiStatus.Result];
        setPlanBenifits(list);
        setShowBenifitsPopup(true);
      } else {
        setPlanBenifits([]);
        setAlert({
          variant: 'error',
          title: 'Plan Benefits',
          description: res?.ApiStatus?.Message || 'No Benefits Found',
        });
      }
    } catch (err) {
      setPlanBenifits([]);
      setAlert({
        variant: 'error',
        title: 'Plan Benefits',
        description: 'Failed to fetch plan benefits',
      });
    } finally {
      setIsLoading(false);
    }
  };

  const validateRequiredFields = () => {
    if (
      [selectedCategory, selectedPlan, depDate, arrDate, numDays, dob].some(
        isEmpty,
      )
    ) {
      return false;
    }
    const requiredPax = [
      'paxname',
      'address1',
      'district',
      'cityName',
      'stateName',
      'zipCode',
      'country',
      'phoneNum',
      'mobile',
      'email',
      'nominee',
      'relation',
    ];
    if (requiredPax.some((k) => isEmpty(paxDetails[k]))) return false;
    if (domint === 'international' && isEmpty(paxDetails.passportNumber))
      return false;
    return true;
  };

  const handleSubmit = () => {
    if (!validateRequiredFields()) {
      setValidationError(true);
      scrollToTop();
      return false;
    }
    setShowFooter(true);
    return true;
  };

  const handleUpdateState = (name, value) => {
    setPaxDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleUpdateTotalamount = (name, amount) => {
    const amountDetails = { ...costDetails, [name]: Number(amount || 0) };
    let totAmount = 0;
    Object.entries(amountDetails).forEach(([key, value]) => {
      if (value !== '') {
        if (key === 'commission') {
          totAmount += Number(value);
        } else {
          totAmount += Number(value);
        }
      }
    });
    setCostDetails(amountDetails);
    setTotalInvoice(totAmount);
  };

  const handleUpdateCostDetails = (name, value) => {
    const numericVal = value === '' || value == null ? '' : Number(value);
    setCostDetails((prev) => ({
      ...prev,
      [name]: numericVal,
    }));
    handleUpdateTotalamount(name, numericVal);
  };

  const getData = async () => {
    setIsLoading(true);
    try {
      const res = await getInsuarnceIds();
      if (res && res.ApiStatus && res.ApiStatus.Status === 'OK') {
        let { Result } = res.ApiStatus;
        Result = Array.isArray(Result) ? Result : [Result];
        const list = [];
        Result.forEach((item) => {
          list.push({ label: item.description, value: item.categorycode });
        });
        setCategoryOptions(list);
      } else {
        setAlert({
          variant: 'error',
          title: 'Insurance',
          description: res?.ApiStatus?.Status || 'Failed to fetch details',
        });
      }
    } catch (err) {
      setAlert({
        variant: 'error',
        title: 'Insurance',
        description: 'Failed to fetch categories',
      });
    } finally {
      setIsLoading(false);
    }
  };
  const handlePgSelect = (pgName) => {
    setSelectedPg(pgName);
  };
  const getPlanOptions = async (value) => {
    setIsLoading(true);
    try {
      const actioncode = 'GETALLPLANSFORCATEGORY';
      const res = await getInsuranceInfo({ actioncode, categorycode: value });
      if (res && res.ApiStatus && res.ApiStatus.Status === 'OK') {
        let { Result } = res.ApiStatus;
        Result = Array.isArray(Result) ? Result : [Result];
        const list = [];
        Result.forEach((item) => {
          list.push({
            label: item.name,
            value: item.plancode,
            ...item,
          });
        });
        setPlanOptions(list);
      } else {
        setPlanOptions([]);
        setAlert({
          variant: 'error',
          title: 'Insurance',
          description: res?.ApiStatus?.Status || 'Failed to fetch details',
        });
      }
    } catch (err) {
      setPlanOptions([]);
      setAlert({
        variant: 'error',
        title: 'Insurance',
        description: 'Failed to fetch plans',
      });
    } finally {
      setIsLoading(false);
    }
  };

  const getPlanRelatedDetails = async (value) => {
    setIsLoading(true);
    try {
      const rideRes = await getInsuranceInfo({
        actioncode: 'ALLRIDERSFORPLAN',
        plancode: value,
      });
      if (rideRes && rideRes.ApiStatus && rideRes.ApiStatus.Status === 'OK') {
        let { Result } = rideRes.ApiStatus;
        Result = Array.isArray(Result) ? Result : [Result];
        if (Result.length > 0) {
          const cloned = Result.map((r) => ({ ...r, showDetails: false }));
          setRidesAvailable(cloned);
        } else {
          setRidesAvailable([]);
        }
      } else {
        setRidesAvailable([]);
      }

      const docRes = await getInsuranceInfo({
        actioncode: 'GETALLDOCUMENTSFORPLAN',
        plancode: value,
      });
      if (docRes && docRes.ApiStatus && docRes.ApiStatus.Status === 'OK') {
        let { Result } = docRes.ApiStatus;
        Result = Array.isArray(Result) ? Result : [Result];
        if (Result.length > 0) {
          setDocumentsRequired(Result);
        } else {
          setDocumentsRequired([]);
        }
      } else {
        setDocumentsRequired([]);
      }
    } catch (err) {
      setRidesAvailable([]);
      setDocumentsRequired([]);
    } finally {
      setIsLoading(false);
    }
  };

  const getPemiumAmountForAge = async (num) => {
    if (numDays !== '' && numDays != null && num) {
      setIsLoading(true);
      try {
        const res = await getInsuranceInfo({
          actioncode: 'GETALLPREMIUMAMTFORPLANNEW',
          plancode: selectedPlan,
          agelimit: num,
          daylimit: numDays,
        });
        if (res && res.ApiStatus && res.ApiStatus.Status === 'OK') {
          const { Result } = res.ApiStatus;
          if (Result && Result.length > 0) {
            const { premium } = Result[0];
            handleUpdateCostDetails('basecharges', premium);
            setHasDetails(true);
          }
        }
      } catch (err) {
        // ignore
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleGetTxDetails = async () => {
    if (txId !== '') {
      setIsLoading(true);
      try {
        const res = await getFlightTicketApi(txId, getUserAgentId());
        if (res && res.ApiStatus && res.ApiStatus.Status === 'OK') {
          const flightInvoice =
            res?.ApiStatus?.Result?.FullFlightDetails?.FlightInvoice;
          const flightRecord = flightInvoice?.FlightRecord;
          if (flightRecord) {
            const fullName = `${flightRecord.PassengerFirstName || ''} ${
              flightRecord.PassengerLastName || ''
            }`.trim();
            handleUpdateState('paxname', fullName);
          } else {
            setAlert({
              variant: 'error',
              title: 'Pax Details',
              description: 'Failed to fetch pax details',
            });
          }
        } else {
          setAlert({
            variant: 'error',
            title: 'Pax Details',
            description: 'Failed to fetch details',
          });
        }
      } catch (err) {
        setAlert({
          variant: 'error',
          title: 'Pax Details',
          description: 'Failed to fetch details',
        });
      } finally {
        setIsLoading(false);
      }
    }
  };

  const resetResults = () => {
    setTxId('');
    setDob('');
    setDocumentsRequired([]);
    setRidesAvailable([]);
    setSelectedRidersCode([]);
    setValidationError(false);
    setDepDate('');
    setArrDate('');
    setNumDays('');
    setNumPax(1);
    setPaxDetails({
      paxname: '',
      address1: '',
      address2: '',
      district: '',
      cityName: '',
      stateName: '',
      zipCode: '',
      country: '',
      phoneNum: '',
      mobile: '',
      email: '',
      nominee: '',
      relation: '',
      passportNumber: '',
      age: '',
    });
    setTotalInvoice(0);
    setShowFooter(false);
    setAcceptTerms(false);
    setCostDetails({
      basecharges: 0,
      handlingcharges: 0,
      servicetax: 0,
      educess: 0,
      higheducess: 0,
      commission: 0,
      tds: 0,
      othetaxes: 0,
    });
    setSelectedRidersCode([]);
    setRiderAmount(0);
  };

  const handleCategorySelect = (e) => {
    try {
      const { value, label } = e;
      setSelectedCategory(value);
      resetResults();
      if (value !== '') {
        getPlanOptions(value);
        setSelectedPlan('');
        setSelectedPlanLabel('');
        if (value !== '') {
          if (label?.toLowerCase().includes('domestic')) {
            setDomint('domestic');
          }
          if (label?.toLowerCase().includes('overseas')) {
            setDomint('international');
          }
        }
      }
    } catch (error) {
      //
    }
  };

  const handlePlanSelect = (e) => {
    try {
      resetResults();
      const { value } = e;
      if (value !== '') {
        getPlanRelatedDetails(value);
      }
      setSelectedPlan(value);
    } catch (error) {
      //
    }
  };

  useEffect(() => {
    getData();
  }, []);
  const handelSetDepDate = (date) => {
    setDepDate(date);
    if (!isEmpty(arrDate)) {
      const diffInDays = differenceInCalendarDays(
        getNewDate(arrDate),
        getNewDate(date),
      );
      setNumDays(diffInDays + 1);
    }
  };
  const handelSetArrDate = (date) => {
    setArrDate(date);
    if (!isEmpty(depDate)) {
      const diffInDays = differenceInCalendarDays(
        getNewDate(date),
        getNewDate(depDate),
      );
      setNumDays(diffInDays + 1);
    }
  };

  const getAge = () => {
    if (dob !== '') {
      const numYears = differenceInYears(
        getNewDate(TODAY_DATE),
        getNewDate(dob),
      );
      if (numYears < 0) {
        setAlert({
          variant: 'error',
          title: 'DOB',
          description: 'Date of birth cannot be in the future',
        });
        handleUpdateState('age', 0);
        return;
      }
      handleUpdateState('age', numYears);
      getPemiumAmountForAge(numYears);
    }
  };

  const handleDobSelect = (date) => {
    setDob(date);
  };

  const handleNumDaysChange = (days) => {
    setNumDays(days);
    if (!isEmpty(depDate) && !isEmpty(days)) {
      const numdays = parseInt(days, 10);
      if (!Number.isNaN(numdays)) {
        const departureDate = getNewDate(depDate);
        // treat numDays as inclusive count -> arrival = dep + (numdays - 1)
        const newDate = addDays(departureDate, Math.max(0, numdays - 1));
        setArrDate(newDate);
      }
    }
  };
  useEffect(() => {
    getAge();
  }, [dob, numDays]);

  const handleContinueBooking = async () => {
    if (!validateRequiredFields()) {
      setValidationError(true);
      scrollToTop();
      return false;
    }
    if (domint === 'international' && isEmpty(paxDetails.passportNumber)) {
      setValidationError(true);
      scrollToTop();
      return false;
    }
    setIsLoading(true);
    const priceDetails = normalizePriceDetails(costDetails);

    const { paxname, age, relation, nominee, country, mobile } = paxDetails;
    const rideCodes = selectedRiderCodes.map((r) => r.ridercode);
    const req = {
      actioncode: 'ISSUETRAVELPOLICY',
      ridercodes: rideCodes.join(','),
      totalbasecharge: 0,
      totalcharges: totalInvoice,
      total_farequote: 0,
      apiname: 'trawelltag',
      paymentmode: paymentMode,
      total_invoice: totalInvoice + Number(riderAmount),
      departuredate: formatDate(
        getNewDate(depDate),
        DATE_MONTH_YEAR_WITH_HYPHEN,
      ),
      arrivaldate: formatDate(getNewDate(arrDate), DATE_MONTH_YEAR_WITH_HYPHEN),
      dob: formatDate(getNewDate(dob), DATE_MONTH_YEAR_WITH_HYPHEN),
      agentid: getUserAgentId(),
      numdays: numDays,
      categorycode: selectedCategory,
      plancode: selectedPlan,
      passportnumber: paxDetails.passportNumber,
      pincode: paxDetails.zipCode,
      state: paxDetails.stateName,
      phoneno: paxDetails.phoneNum,
      city: paxDetails.cityName,
      emailaddress: paxDetails.email,
      address1: paxDetails.address1,
      address2: paxDetails.address2,
      district: paxDetails.district,
      mobile,
      country,
      paxname,
      age,
      nominee,
      relation,
      domint,
      rideramount: riderAmount,
      ...priceDetails,
      markup: 0,
    };
    try {
      const res = await getInsuranceInfo(req);
      if (res && res.ApiStatus && res.ApiStatus.Status === 'OK') {
        setAlert({
          variant: 'success',
          title: 'Insurance',
          description: res.ApiStatus.Message,
        });
        const result = res?.ApiStatus?.Result;
        const pgUrl = result?.PgUrl;
        const txid = result?.Txid;
        if (pgUrl && txid) {
          const finalUrl = `${pgUrl}?txid=${encodeURIComponent(txid)}`;
          window.open(finalUrl, '_blank');
          window.location.reload();
        } else {
          // something
        }
      } else {
        setAlert({
          variant: 'error',
          title: 'Insurance',
          description: res?.ApiStatus?.Message || 'Failed to book Insurance',
        });
      }
    } catch (err) {
      setAlert({
        variant: 'error',
        title: 'Insurance',
        description: 'Unexpected error while issuing policy',
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleFetchAmountForRiderPlan = async (
    ridePlanCode,
    index,
    isShown,
  ) => {
    setIsLoading(true);
    try {
      const list = ridesAvailable.slice();
      if (!list[index]) {
        setIsLoading(false);
        return;
      }
      if (list[index].Name) {
        setIsLoading(false);
        return;
      }

      const req = {
        actioncode: 'GETPREMIUMFORRIDERS',
        ridercode: ridePlanCode,
      };
      const res = await getInsuranceInfo(req);
      if (res && res.ApiStatus && res.ApiStatus.Status === 'OK') {
        const { Result } = res.ApiStatus;
        if (
          Result != null &&
          Result !== '' &&
          Result !== undefined &&
          Result.length > 0
        ) {
          list[index] = {
            ...list[index],
            Name: Result[0].name,
            Amount: Result[0].amount,
            Currency: Result[0].currency,
            Deductibles: Result[0].deductibles,
            showDetails: true,
          };
          setRidesAvailable(list);
        }
      }
    } catch (err) {
      // ignore
    } finally {
      setIsLoading(false);
    }
  };

  const handleSelectRidePlan = (ride) => {
    setSelectedRidersCode((prevItems) => {
      if (
        prevItems.some(
          (selectedItem) => selectedItem.ridercode === ride.ridercode,
        )
      ) {
        return prevItems.filter(
          (selectedItem) => selectedItem.ridercode !== ride.ridercode,
        );
      }
      return [...prevItems, ride];
    });
  };

  const isRideSelected = (ride) =>
    selectedRiderCodes.some((x) => x.ridercode === ride.ridercode);

  const getRidersPercentage = () => {
    let ridePercent = 0;
    if (selectedRiderCodes.length > 0) {
      selectedRiderCodes.forEach((ride) => {
        ridePercent += Number(ride.premiumpercent || 0);
      });
    }
    const base = Number(costDetails.basecharges || 0);
    const riderCharge = Math.ceil((base * ridePercent) / 100);
    setRiderAmount(riderCharge);

    setTotalInvoice((prev) => {
      return prev;
    });
  };

  useEffect(() => {
    getRidersPercentage();
  }, [selectedRiderCodes, costDetails.basecharges]);
  const handleCheckout = async () => {
    try {
      setLoading(true);
      const amountToSend = totalInvoice + Number(riderAmount);
      const pgcheckoutamount = await getPGCheckOutAmountApi(
        paymentMode,
        selectedPg,
        '',
        amountToSend,
        'insurance',
        getUserAgentId(),
        bankId,
      );

      if (pgcheckoutamount?.ApiStatus?.Status === 'OK') {
        const { Result } = pgcheckoutamount.ApiStatus;

        setcheckoutPgCharge(Result?.PgCharges ?? 0);
        setgstcheckoutPgCharge(Result?.GSTOnPgCharges ?? 0);
        setcheckoutInvTotal(Result?.TotalInvoice ?? 0);
      } else {
        setAlert({
          variant: 'error',
          title: 'Checkout',
          description:
            pgcheckoutamount?.ApiStatus?.Message || 'Failed to fetch charges',
        });
      }
      if (
        Object.keys(errorsObj || {}).length === 0 &&
        Object.keys(paxErrorDict || {}).length === 0
      ) {
        setShowConfirmationPopup(true);
      } else {
        setAlert({
          variant: 'error',
          title: 'Validation',
          description: 'Please fix validation errors before checkout',
        });
      }
    } catch (error) {
      setAlert({
        variant: 'error',
        title: 'Checkout',
        description: 'Unexpected error during checkout',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSendEmail = async () => {
    setIsLoading(true);
    try {
      let fromEmail = '';
      let fromName = '';
      const res = await getUserDetails(getUserAgentId());
      if (res?.ApiStatus?.Status === 'OK') {
        const { User } = res.ApiStatus.Result;
        if (!isEmpty(User)) {
          setAgent(User);
        }
        fromEmail = User.ContactEmail;
        fromName = `${User.FirstName} ${User.LastName}`;
        const content =
          document.getElementById('insuranceEmailContent')?.innerHTML || '';
        const response = await emailFlightOptions(
          fromEmail,
          fromName,
          emailToSent,
          content,
          'Your booking details for Travel Insurance',
        );
        if (response && response?.Root?.Status === 'OK') {
          setAlert({
            title: 'Email',
            description: 'Email Sent Successfully',
            variant: 'success',
          });
          setEmailToSent('');
          setShowEmailModal(false);
          setIsLoading(false);
        } else {
          setAlert({
            title: 'Email',
            description: response?.Root?.Message
              ? response?.Root?.Message
              : 'Failed to send email',
            variant: 'error ',
          });
          setEmailToSent('');
          setShowEmailModal(false);
          setIsLoading(false);
        }
      } else {
        setAlert({
          title: 'User Details',
          description: res?.ApiStatus?.Message
            ? res?.ApiStatus?.Message
            : 'Failed to load Agent Details',
          variant: 'error ',
        });
        setEmailToSent('');
        setShowEmailModal(false);
        setIsLoading(false);
      }
    } catch (error) {
      setShowEmailModal(false);
      setIsLoading(false);
      setAlert({
        title: 'User Details',
        description: 'Failed to load Agent Details',
        variant: 'error ',
      });
    }
  };

  const updatePaymentMode = (pmselected) => {
    setPaymentMode(pmselected);
    const pgForPmSelected = selectedPaymentGatewayRef.current.filter(
      (x) => x.PaymentMode.toLowerCase() === pmselected,
    );
    if (pgForPmSelected.length > 0) {
      setSelectedPg(pgForPmSelected[0].GatewayName);
    }
    setTempPgList(pgForPmSelected);
  };

  const handleCloseEmailModal = () => {
    setShowEmailModal(false);
    setEmailToSent('');
  };
  return (
    <div className="visa-page pb-3">
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          description={alert.description}
          onHide={() => setAlert(undefined)}
        />
      )}
      {categoryOptions.length > 0 && (
        <>
          <div className="visa-page_banner" />
          <div className="visa-page_container">
            <div className="visa-page_container_header">Insurance</div>
            <div className="visa-page_container_form my-2">
              <Row>
                <Col lg={3} md={4} sm={6} xs={12}>
                  <AppSelect
                    required
                    name="category"
                    placeholder=""
                    label="Category"
                    options={categoryOptions}
                    onSelect={handleCategorySelect}
                    isClearable={false}
                    selectedValue={selectedCategory}
                    errorText={validationError && 'please select category'}
                  />
                </Col>
                {planOptions.length > 0 && (
                  <Col lg={3} md={4} sm={6} xs={12}>
                    <AppSelect
                      required
                      name="plans"
                      placeholder=""
                      label="Plans"
                      options={planOptions}
                      onSelect={handlePlanSelect}
                      isClearable={false}
                      selectedValue={selectedPlan}
                      errorText={validationError && 'please select plan'}
                    />
                  </Col>
                )}
                {!isEmpty(selectedPlan) && (
                  <Col
                    lg={3}
                    md={4}
                    sm={6}
                    xs={12}
                    className="d-flex align-items-center fs-14"
                  >
                    <AppLink
                      linkText="Plan Benefits"
                      onClick={handleGetPlanBenifits}
                    />
                  </Col>
                )}
              </Row>
              {selectedPlan !== '' && (
                <>
                  <div className="separator my-3" />
                  <div className="mt-2">
                    <Row className="spacing-16">
                      <Col lg={3} md={3} sm={4} xs={6}>
                        <AppDatePicker
                          label="Departure Date"
                          className="app-date-picker"
                          customClassName={`position-relative  ${
                            validationError && depDate === ''
                              ? 'app-error-text-border'
                              : ''
                          }`}
                          required
                          placeholder=""
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          isCustomeInput={false}
                          minDate={getNewDate(TODAY_DATE)}
                          maxDate={arrDate !== '' ? arrDate : ''}
                          selectedDate={depDate}
                          onChange={(date) => handelSetDepDate(date)}
                          labelClassName="app-date-label"
                        />
                        {validationError && depDate === '' && (
                          <small className="app-error-text">
                            select arrival date
                          </small>
                        )}
                      </Col>
                      <Col lg={3} md={3} sm={4} xs={6}>
                        <AppDatePicker
                          required
                          label="Arrival Date"
                          className="app-date-picker"
                          customClassName={`position-relative  ${
                            validationError && arrDate === ''
                              ? 'app-error-text-border'
                              : ''
                          }`}
                          placeholder=""
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          isCustomeInput={false}
                          minDate={
                            depDate !== '' ? depDate : getNewDate(TODAY_DATE)
                          }
                          selectedDate={arrDate}
                          onChange={(date) => handelSetArrDate(date)}
                          labelClassName="app-date-label"
                        />
                        {validationError && arrDate === '' && (
                          <small className="app-error-text">
                            select arrival date
                          </small>
                        )}
                      </Col>
                      <Col lg={3} md={3} sm={4} xs={6}>
                        <AppNumberInput
                          required
                          placeholderText=""
                          name="numDays"
                          label="No.of Days"
                          value={numDays}
                          onChange={(d) => handleNumDaysChange(d)}
                          errorText={
                            validationError && 'please enter no of days'
                          }
                        />
                      </Col>
                      <Col lg={3} md={4} sm={6} xs={12}>
                        <AppSelect
                          required
                          name="numPax"
                          placeholder=""
                          label="No.of pax"
                          options={[{ label: '1', value: 1 }]}
                          onSelect={(dataObj) => setNumPax(dataObj.value)}
                          isClearable={false}
                          selectedValue={numPax}
                        />
                      </Col>
                      <Col lg={3} md={3} sm={4} xs={6}>
                        <AppDatePicker
                          required
                          label="Date of Birth"
                          className="app-date-picker"
                          customClassName={`position-relative  ${
                            validationError && dob === ''
                              ? 'app-error-text-border'
                              : ''
                          }`}
                          placeholder=""
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          isCustomeInput={false}
                          maxDate={getNewDate(TODAY_DATE)}
                          selectedDate={dob}
                          onChange={handleDobSelect}
                          labelClassName="app-date-label"
                        />
                        {validationError && dob === '' && (
                          <small className="app-error-text">
                            select birth date
                          </small>
                        )}
                      </Col>
                      <Col lg={3} md={4} sm={6} xs={12}>
                        <AppNumberInput
                          required
                          placeholderText=""
                          name="age"
                          label="Age(min 6m, max 70y)"
                          value={paxDetails.age}
                          disabled
                        />
                      </Col>
                      <Col
                        lg={3}
                        md={4}
                        sm={6}
                        xs={12}
                        className="d-flex align-items-center justify-content-between"
                      >
                        <AppButton
                          btnText={isContinue ? 'Hide' : 'Continue'}
                          variant="secondary"
                          onClick={() => setIsContinue((prev) => !prev)}
                        />
                        {hasDetails && (
                          <AppLink
                            linkText="Share Details"
                            className="fs-14"
                            onClick={() => setShowEmailModal(true)}
                          />
                        )}
                        <div id="insuranceEmailContent" className="d-none">
                          <div
                            style={{
                              border: '1px solid #ccc',
                              padding: '10px',
                              margin: '10px',
                            }}
                          >
                            <p
                              style={{
                                fontWeight: '600',
                              }}
                            >
                              Dear Partner,
                            </p>
                            <p>
                              As per your request, we are forwarding Travel
                              insurance policy
                            </p>
                            <div
                              style={{
                                backgroundColor: '#0770e4',
                                color: '#fff',
                                border: '1px solid #0770e4',
                              }}
                            >
                              <table style={{ width: '100%' }}>
                                <thead>
                                  <tr>
                                    <th>{selectedPlanlabel}</th>
                                    <th style={{ textAlign: 'right' }}>
                                      Price: Rs {costDetails.basecharges}
                                    </th>
                                  </tr>
                                </thead>
                              </table>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  {isContinue && (
                    <>
                      <div className="separator my-3" />
                      <div className="mt-2">
                        <Row className="spacing-16">
                          <Col lg={12}>
                            <Row className="spacing-16">
                              <Col lg={3} md={4} sm={6} xs={12}>
                                <AppTextInput
                                  placeholderText=""
                                  name="txid"
                                  label="Enter Txid (if exits)"
                                  value={txId}
                                  onChange={(e) => setTxId(e.target.value)}
                                />
                              </Col>
                              <Col lg={3} md={4} sm={6} xs={12}>
                                <AppButton
                                  btnText="Get pax Details"
                                  variant="outlined"
                                  onClick={handleGetTxDetails}
                                />
                              </Col>
                            </Row>
                          </Col>
                          <Col lg={3} md={4} sm={6} xs={12}>
                            <AppTextInput
                              required
                              placeholderText=""
                              name="paxname"
                              label="Pax Name"
                              value={paxDetails.paxname}
                              onChange={(e) =>
                                handleUpdateState('paxname', e.target.value)
                              }
                              errorText={
                                validationError && 'please enter pax name'
                              }
                            />
                          </Col>
                          <Col lg={3} md={4} sm={6} xs={12}>
                            <AppTextInput
                              required
                              placeholderText=""
                              name="address1"
                              label="Address 1"
                              value={paxDetails.address1}
                              onChange={(e) =>
                                handleUpdateState('address1', e.target.value)
                              }
                              errorText={
                                validationError && 'please enter address1'
                              }
                            />
                          </Col>
                          <Col lg={3} md={4} sm={6} xs={12}>
                            <AppTextInput
                              placeholderText=""
                              name="address2"
                              label="Address 2"
                              value={paxDetails.address2}
                              onChange={(e) =>
                                handleUpdateState('address2', e.target.value)
                              }
                            />
                          </Col>
                          <Col lg={3} md={4} sm={6} xs={12}>
                            <AppTextInput
                              required
                              placeholderText=""
                              name="district"
                              label="District"
                              value={paxDetails.district}
                              onChange={(e) =>
                                handleUpdateState('district', e.target.value)
                              }
                              errorText={
                                validationError && 'please enter District'
                              }
                            />
                          </Col>
                          <Col lg={3} md={4} sm={6} xs={12}>
                            <AppTextInput
                              required
                              placeholderText=""
                              name="cityName"
                              label="City Name"
                              value={paxDetails.cityName}
                              onChange={(e) =>
                                handleUpdateState('cityName', e.target.value)
                              }
                              errorText={
                                validationError && 'please enter city name'
                              }
                            />
                          </Col>
                          <Col lg={3} md={4} sm={6} xs={12}>
                            <AppTextInput
                              required
                              placeholderText=""
                              name="stateName"
                              label="State Name"
                              value={paxDetails.stateName}
                              onChange={(e) =>
                                handleUpdateState('stateName', e.target.value)
                              }
                              errorText={
                                validationError && 'please enter state'
                              }
                            />
                          </Col>
                          <Col lg={3} md={4} sm={6} xs={12}>
                            <AppNumberInput
                              required
                              placeholderText=""
                              name="zipCode"
                              label="Zip Code"
                              value={paxDetails.zipCode}
                              onChange={(e) => handleUpdateState('zipCode', e)}
                              errorText={
                                validationError && 'please enter zip code'
                              }
                            />
                          </Col>
                          <Col lg={3} md={4} sm={6} xs={12}>
                            <AppTextInput
                              required
                              placeholderText=""
                              name="country"
                              label="Country"
                              value={paxDetails.country}
                              onChange={(e) =>
                                handleUpdateState('country', e.target.value)
                              }
                              errorText={
                                validationError && 'please enter country'
                              }
                            />
                          </Col>
                          <Col lg={3} md={3} sm={6} xs={12}>
                            <AppNumberInput
                              required
                              placeholderText=""
                              name="phoneNum"
                              label="Phone Number"
                              value={paxDetails.phoneNum}
                              onChange={(e) => handleUpdateState('phoneNum', e)}
                              errorText={
                                validationError && 'please enter phone number'
                              }
                            />
                          </Col>
                          <Col lg={3} md={4} sm={6} xs={12}>
                            <AppNumberInput
                              required
                              placeholderText=""
                              name="mobile"
                              label="Mobile"
                              value={paxDetails.mobile}
                              onChange={(e) => handleUpdateState('mobile', e)}
                              errorText={
                                validationError && 'please enter mobile'
                              }
                            />
                          </Col>
                          <Col lg={3} md={4} sm={6} xs={12}>
                            <AppTextInput
                              required
                              placeholderText=""
                              name="email"
                              label="Email"
                              value={paxDetails.email}
                              onChange={(e) =>
                                handleUpdateState('email', e.target.value)
                              }
                              errorText={
                                validationError && 'please enter email'
                              }
                            />
                          </Col>
                        </Row>
                        <div className="separator my-3" />
                        <Row className="spacing-16">
                          <Col lg={3} md={4} sm={6} xs={12}>
                            <AppTextInput
                              required
                              placeholderText=""
                              name="nominee"
                              label="Nominee"
                              value={paxDetails.nominee}
                              onChange={(e) =>
                                handleUpdateState('nominee', e.target.value)
                              }
                              errorText={
                                validationError && 'please enter nominee'
                              }
                            />
                          </Col>
                          <Col lg={3} md={4} sm={6} xs={12}>
                            <AppTextInput
                              required
                              placeholderText=""
                              name="relation"
                              label="Relation"
                              value={paxDetails.relation}
                              onChange={(e) =>
                                handleUpdateState('relation', e.target.value)
                              }
                              errorText={
                                validationError && 'please enter relation'
                              }
                            />
                          </Col>
                          <Col lg={3} md={4} sm={6} xs={12}>
                            <AppTextInput
                              required={domint === 'international'}
                              placeholderText=""
                              name="passportNumber"
                              label="Passport Number"
                              value={paxDetails.passportNumber}
                              onChange={(e) =>
                                handleUpdateState(
                                  'passportNumber',
                                  e.target.value,
                                )
                              }
                              errorText={
                                validationError &&
                                domint === 'international' &&
                                'please enter passport'
                              }
                            />
                          </Col>
                        </Row>
                      </div>
                    </>
                  )}
                  <div className="separator my-3" />
                  <div className="my-2">
                    <Row className="spacing-8">
                      <Col lg={6} md={6} sm={6} xs={12} className="d-flex p-2">
                        <div className="flex-1 rides-container">
                          <div className="rides-container_header">Riders</div>
                          {ridesAvailable.length > 0 && (
                            <div className="p-2 fs-14 d-flex flex-column gap-1">
                              <table className="table-bordered text-center">
                                <thead>
                                  <tr>
                                    <th>Select</th>
                                    <th>%</th>
                                    <th>Details</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {ridesAvailable.map((ride, index) => (
                                    <React.Fragment
                                      key={ride.ridercode || index}
                                    >
                                      <tr>
                                        <td>
                                          <AppCheckBox
                                            id={ride.ridercode}
                                            onChange={() =>
                                              handleSelectRidePlan(ride)
                                            }
                                            labelClassName="justify-content-center"
                                            checked={isRideSelected(ride)}
                                          />
                                        </td>
                                        <td>{ride.premiumpercent}</td>
                                        <td>
                                          <AppLink
                                            linkText="Details"
                                            variant="primary"
                                            onClick={() =>
                                              handleFetchAmountForRiderPlan(
                                                ride.ridercode,
                                                index,
                                                ride.showDetails,
                                              )
                                            }
                                          />
                                        </td>
                                      </tr>
                                      {ride.showDetails && (
                                        <tr>
                                          <td className="p-1" colSpan={3}>
                                            <table className="w-100 table-bordered fs-12">
                                              <thead>
                                                <tr>
                                                  <th>Name</th>
                                                  <th>Amount</th>
                                                  <th>Deductibles</th>
                                                  <th>Currency</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                <tr>
                                                  <td>{ride.Name}</td>
                                                  <td>{ride.Amount}</td>
                                                  <td>{ride.Deductibles}</td>
                                                  <td>{ride.Currency}</td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                      )}
                                    </React.Fragment>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          )}
                        </div>
                      </Col>
                      <Col lg={3} md={3} sm={6} xs={12} className="d-flex p-2">
                        <div className="flex-1 rides-container">
                          <div className="rides-container_header">
                            Documents
                          </div>
                          {documentsRequired.length > 0 && (
                            <div className="p-2 fs-14 d-flex flex-column gap-1">
                              {documentsRequired.map((doc) => (
                                <span key={doc.documentcode}>
                                  {doc.documentname}
                                </span>
                              ))}
                            </div>
                          )}
                        </div>
                      </Col>
                      <Col lg={3} md={3} sm={6} xs={12} className="d-flex p-2">
                        <div className="flex-1 rides-container gap-2">
                          <div>
                            <AppNumberInput
                              placeholderText=""
                              name="basecharges"
                              label="Base Charge"
                              value={costDetails.basecharges}
                              disabled
                            />
                          </div>
                          <div>
                            <AppNumberInput
                              placeholderText=""
                              name="handlingcharges"
                              label="Management Fee"
                              value={costDetails.handlingcharges}
                              onChange={(e) =>
                                handleUpdateCostDetails('handlingcharges', e)
                              }
                            />
                          </div>
                          <div>
                            <AppNumberInput
                              placeholderText=""
                              name="servicetax"
                              label="Service Tax"
                              value={costDetails.servicetax}
                              onChange={(e) =>
                                handleUpdateCostDetails('servicetax', e)
                              }
                            />
                          </div>
                          <div>
                            <AppNumberInput
                              placeholderText=""
                              name="educess"
                              label="Edu cess"
                              value={costDetails.educess}
                              onChange={(e) =>
                                handleUpdateCostDetails('educess', e)
                              }
                            />
                          </div>
                          <div>
                            <AppNumberInput
                              placeholderText=""
                              name="higheducess"
                              label="HighEdu cess"
                              value={costDetails.higheducess}
                              onChange={(e) =>
                                handleUpdateCostDetails('higheducess', e)
                              }
                            />
                          </div>
                          <div>
                            <AppNumberInput
                              placeholderText=""
                              name="commission"
                              label="Commission"
                              value={costDetails.commission}
                              onChange={(e) =>
                                handleUpdateCostDetails('commission', e)
                              }
                            />
                          </div>
                          <div>
                            <AppNumberInput
                              placeholderText=""
                              name="tds"
                              label="TDS"
                              value={costDetails.tds}
                              onChange={(e) =>
                                handleUpdateCostDetails('tds', e)
                              }
                            />
                          </div>
                          <div>
                            <AppNumberInput
                              placeholderText=""
                              name="othetaxes"
                              label="Other Taxes"
                              value={costDetails.othetaxes}
                              onChange={(e) =>
                                handleUpdateCostDetails('othetaxes', e)
                              }
                            />
                          </div>
                          <div>
                            <AppNumberInput
                              placeholderText=""
                              name="ridersAmount"
                              label="Rider Total"
                              value={Number(riderAmount)}
                              disabled
                            />
                          </div>
                          <div>
                            <AppNumberInput
                              placeholderText=""
                              name="totalInvoice"
                              label="Total Invoice"
                              value={totalInvoice + Number(riderAmount)}
                              disabled
                            />
                          </div>
                          <div className="d-flex">
                            <span className="mt-2 fw-400 d-flex align-items-center flex-1 justify-content-between">
                              Total Premium Amount is{' '}
                              <span className="fw-600">
                                {totalInvoice + Number(riderAmount)}
                              </span>
                            </span>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  {isContinue && (
                    <div className="d-flex justify-content-center mt-2">
                      <AppButton
                        btnText="Submit"
                        variant="outlined"
                        className="px-4"
                        onClick={handleSubmit}
                      />
                    </div>
                  )}
                  {showFooter && (
                    <div>
                      <div className="fs-12">
                        <p>
                          I declare that the information provided in this
                          application is correct.
                        </p>
                        <p>
                          The insured is currently in India and is a resident of
                          India holding a valid Indian passport/Indian work or
                          residence permit.The applicant is above 18 years of
                          age.
                        </p>
                        <p>
                          I also confirm that this policy is not being issued to
                          cover risks directly or indirectly associated with
                          travel in, to, or through Afghanistan, Cuba or
                          Democratic Republic of Congo. I/ We hereby declare, on
                          my behalf and on behalf of all persons proposed to be
                          insured that the above statements, answers and/or
                          particulars given by me are true and complete in all
                          respects to the best of my knowledge and that I/We am/
                          are authorized to propose on behalf of these other
                          persons.
                        </p>
                        <p>
                          I/ We understand that the information provided by me
                          will form the basis of insurance policy, is subject to
                          the Board approved underwriting policy of the
                          Insurance company and that the policy will come into
                          force only after full receipt of the premium
                          chargeable.
                        </p>
                        <p>
                          I/ We further declare that I/We will notify in writing
                          any change occurring in the occupation or general
                          health of the life to be insured/ proposer after the
                          proposal has been submitted but before communication
                          of the risk acceptance by the company.
                        </p>
                        <p>
                          I/We declare and consent to the company seeking
                          medical information from any doctor or from a hospital
                          who at anytime has attended on the life to be insured/
                          proposer or from any past or present employer
                          concerning anything which affects the physical and
                          mental health of the life to be assured/proposer and
                          seeking information from any insurance company to
                          which an application for insurance on the life to be
                          assured/ proposer has been made for the purpose of
                          underwriting the proposal and/or claim settlement.
                        </p>
                        <p>
                          I/ We authorize the company to share information
                          pertaining to my proposal including the medical
                          records for the sole purpose of proposal underwriting
                          and/or claims settlement and with any Governmental
                          and/or Regulatory Authority.
                        </p>
                      </div>
                      <div className="mt-2 fs-12">
                        <p>AML guidelines:</p>
                        <p>
                          1. I/We hereby confirm that all premiums have
                          been/will be paid from bonafide sources and no
                          premiums have been/will be paid out of proceeds of
                          crime related to any of the offence listed in
                          preventions of Money Laundering Act, 2002.
                        </p>
                        <p>
                          2. I understand that the Company has the right to call
                          for documents to establish sources of funds.
                        </p>
                        <p>
                          3. The insurance Company has right to cancel the
                          insurance contract in case I am/have been found guilty
                          by any competent court of law under any of the
                          statutes,directly or indirectly governing the
                          prevention of money laundering in India.
                        </p>
                        <p>
                          I have read and understood the above mention Terms &
                          Conditions.
                        </p>
                        <p className="my-3">
                          Section 41 of Insurance Act 1938 (Prohibition of
                          rebates): Statutory warning - 1. &quot;No person shall
                          allow or offer to allow either directly or indirectly
                          as an inducement to any person to take out or renew or
                          continue an insurance in respect of any kind of risk
                          relating to lives or property in India, any rebate of
                          the whole or part of the commission payable or any
                          rebate of premium shown on the policy, nor shall any
                          person taking out or renewing or continuing a policy
                          accept any rebate, except such rebate as may be
                          allowed in accordance with the published prospectus or
                          tables of the insurers&quot;. 2. If any person fails
                          to comply with sub regulation (1) above, he shall be
                          liable to payment of a fine which may extend to rupees
                          five hundred.
                        </p>
                        <p>64VB:</p>
                        <p className="mb-3">
                          Commencement of risk cover under the policy is subject
                          to receipt and realisation of payable premium by Tata
                          AIG General Insurance Company Limited.
                        </p>
                        <p>General Exclusions:</p>
                        <p>
                          1. Insured Person is traveling against the advice of a
                          Physician; or is travelling for the purpose of
                          obtaining treatment.
                        </p>
                        <p>
                          2. Any Pre-existing Condition or any complication
                          arising from it; or
                        </p>
                        <p>
                          3. Suicide, attempted suicide (whether sane or insane)
                          or intentionally self inflicted Injury or Illness, or
                          sexually transmitted conditions, mental or nervous
                          disorder, anxiety, stress or depression, Acquired
                          Immune Deficiency Syndrome (AIDS), Human Immune
                          deficiency Virus (HIV) infection; or
                        </p>
                        <p>
                          4. Serving in any branch of the Military or Armed
                          Forces of any country, whether in peace or War,
                        </p>
                        <p>
                          5. Being under the influence of drugs, alcohol, or
                          other intoxicants or hallucinogens
                        </p>
                        <p>
                          6. Participation in an actual or attempted felony,
                          riot, crime, misdemeanor, or civil commotion; or
                        </p>
                        <p>
                          7. Operating or learning to operate any aircraft, or
                          performing duties as a member of the crew on any
                          aircraft or Scheduled Airline; or
                        </p>
                        <p>
                          8. Any loss arising out of War, civil war, invasion,
                          insurrection, revolution, act of foreign enemy,
                        </p>
                        <p>
                          9. Any loss, damage cost or expense of whatsoever
                          nature directly or indirectly caused by, resulting
                          from or in connection with any act of terrorism.
                        </p>
                        <p>
                          10. Any loss arising out of the intentional use of
                          military force to intercept, prevent, or mitigate any
                          known or suspected Act of Terrorism;or
                        </p>
                        <p>
                          11. The use, release or escape of nuclear materials
                          that directly or indirectly results in nuclear
                          reaction or radiationor radioactive contamination;
                        </p>
                        <p>
                          12. The radioactive, toxic, explosive or other
                          dangerous properties of any explosive nuclear
                          equipment or any part of that equipment; or
                        </p>
                        <p>
                          13. Performance of manual work for employment or any
                          other potentially dangerous occupation; or
                        </p>
                        <p>
                          14. Congenital anomalies or any complications or
                          conditions arisingtherefrom; or
                        </p>
                        <p>
                          15. Osteoporosis (porosity and brittleness of the
                          bones due to loss of protein from the bones matrix) or
                          pathological fracture (any fracture in an area where
                          pre-existing Disease has caused the weakening of the
                          bone)
                        </p>
                        <p>
                          16. Participation in winter sports,
                          skydiving/parachuting, hang gliding, bungee jumping,
                          scuba diving, mountain climbing
                        </p>
                        <p>
                          17. Pregnancy and all related conditions, This however
                          does not include ectopic pregnancy proved by
                          diagnostic means and is certified to be life
                          threatening by the Physician; or
                        </p>
                        <p>
                          18. For any loss of which a contributing cause was
                          your actual or attempted commission of, or willful
                          participation in, an illegal act or any violation or
                          attempted violation of the law or Your resistance to
                          arrest;
                        </p>
                        <p>
                          19. Any loss, injury, damage or legal liability
                          arising directly or indirectly from: Travel in, to, or
                          through Afghanistan, Cuba or Democratic Republic of
                          Congo; or
                        </p>
                        <p>
                          20. Any loss, injury, damage or legal sustained
                          directly or indirectly by: Any terrorist or member of
                          a terrorist organisation, narcotics trafficker, or
                          purveyor of nuclear, chemical or biological weapons.
                        </p>
                        <p className="mt-2">
                          For complete list of detailed exclusion, please refer
                          policy wordings
                        </p>
                        <p>
                          I have read and understood the policy wordings adsfafd
                        </p>
                      </div>

                      <div className="separator" />
                      <div>
                        <div className="flight-booking-page_content">
                          <div className="flight-booking-page_title">
                            Payment options
                          </div>
                          <div className="d-flex cursor-pointer">
                            {getEligibilityForPaymentMode('wallet') && (
                              // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                              <div
                                className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center fw-500 ${
                                  paymentMode === 'cashcard'
                                    ? 'primary-color'
                                    : 'grey-color'
                                }`}
                                onClick={() => updatePaymentMode('cashcard')}
                              >
                                <CiWallet />
                                Wallet
                              </div>
                            )}
                            {getEligibilityForPaymentMode('creditcard') && (
                              // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                              <div
                                className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center fw-500 ${
                                  paymentMode === 'creditcard'
                                    ? 'primary-color'
                                    : 'grey-color'
                                }`}
                                onClick={() => updatePaymentMode('creditcard')}
                              >
                                <MdOutlineCreditCard /> CreditCard
                              </div>
                            )}
                            {getEligibilityForPaymentMode('debitcard') && (
                              // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                              <div
                                className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center fw-500 ${
                                  paymentMode === 'debitcard'
                                    ? 'primary-color'
                                    : 'grey-color'
                                }`}
                                onClick={() => updatePaymentMode('debitcard')}
                              >
                                <MdOutlineCreditCard /> DebitCard
                              </div>
                            )}
                            {getEligibilityForPaymentMode('netbanking') && (
                              // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                              <div
                                className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center fw-500 ${
                                  paymentMode === 'netbanking'
                                    ? 'primary-color'
                                    : 'grey-color'
                                }`}
                                onClick={() => updatePaymentMode('netbanking')}
                              >
                                <CiBank />
                                Netbanking
                              </div>
                            )}
                            {getEligibilityForPaymentMode('upi') && (
                              // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                              <div
                                className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center fw-500 ${
                                  paymentMode === 'upi'
                                    ? 'primary-color'
                                    : 'grey-color'
                                }`}
                                onClick={() => updatePaymentMode('upi')}
                              >
                                <CiBank />
                                UPI
                              </div>
                            )}
                          </div>
                          {paymentMode !== 'cashcard' && paymentMode !== '' && (
                            <PaymentGatewayApii
                              paymentModeClicked={paymentMode}
                              selectedPgForPaymentMode={selectedPg}
                              onPgSelect={handlePgSelect}
                            />
                          )}
                          {paymentMode === 'netbanking' &&
                            (selectedPg === 'techprocessv2' ||
                              selectedPg === 'techprocessv2_netbanking') &&
                            paymentMode !== 'cashcard' &&
                            paymentMode !== '' && (
                              <div className="d-flex justify-content-start p-3">
                                <AppSelect
                                  name="selected_bank"
                                  id="selected_bank"
                                  label="Select Bank"
                                  placeholder=""
                                  required
                                  selectWidth="300px"
                                  isClearable={false}
                                  options={NET_BANKING_OPTIONS_LIVE}
                                  selectedValue={selectedBankForNetBanking}
                                  onSelect={(dataObj) =>
                                    setSelectedBankForNetBanking(dataObj.value)
                                  }
                                />
                              </div>
                            )}
                          {paymentMode === 'netbanking' &&
                            selectedPg === 'payu' &&
                            paymentMode !== 'cashcard' &&
                            paymentMode !== '' && (
                              <div className="d-flex justify-content-start p-3">
                                <AppSelect
                                  name="selected_bank"
                                  id="selected_bank"
                                  label="Select Bank"
                                  placeholder=""
                                  required
                                  selectWidth="300px"
                                  isClearable={false}
                                  options={PAYU_BANKING_OPTIONS_LIVE}
                                  selectedValue={selectedBankForNetBanking}
                                  onSelect={(dataObj) =>
                                    setSelectedBankForNetBanking(dataObj.value)
                                  }
                                />
                              </div>
                            )}
                          {paymentMode !== '' &&
                            paymentMode !== 'cashcard' &&
                            selectedPg === 'payu' && (
                              <div className="px-3 d-flex flex-column">
                                <p className="mb-2 px-4 fs-14">
                                  Accept Terms and Conditions of <b>payu</b>
                                </p>
                                <AppCheckBox
                                  labelText={`${agent.Company} certifies that the Credit/Debit Card/Net Banking Account being used for this transaction belongs to ${agent.Company} or an authorized employee of ${agent.Company}. In particular, this Card/Net Banking Account does not belong to a customer or passenger.`}
                                  id="payuPgAccepted"
                                  name="payuPgAccepted"
                                  radioClassName="w-25px"
                                  checked={isPayuPgAccepted}
                                  labelClassName="fs-12"
                                  onChange={() =>
                                    setIsPayuPgAccepted((prev) => !prev)
                                  }
                                />
                                <div className="d-flex align-items-center fs-12 ps-sm-4 my-2 ps-2 gap-1">
                                  <img
                                    src="/images/others/payu.jpg"
                                    alt=""
                                    height="20px"
                                  />
                                  <img
                                    src="/images/others/visa_mastercard.gif"
                                    alt=""
                                    height="20px"
                                  />
                                  <span>
                                    (Only Personal Credit Cards @ 1.77% | Rupay
                                    Debit Card allowed @0.25%)
                                  </span>
                                </div>
                              </div>
                            )}
                        </div>
                      </div>
                      <div className="d-flex flex-column gap-2 align-items-center">
                        <AppCheckBox
                          labelText="I agree the Terms & Conditions"
                          id="acceptTerms"
                          name="acceptTerms"
                          checked={acceptTerms}
                          labelClassName="fs-12"
                          onChange={() => setAcceptTerms((prev) => !prev)}
                        />
                        <AppButton
                          btnText="Continue Booking"
                          variant="primary"
                          disabled={!acceptTerms}
                          onClick={handleCheckout} // <-- use checkout to fetch PG charges and show confirmation
                        />
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
          {showConfirmationPopup && (
            <AppModal
              modalTitle="Confirm Payment"
              size="md"
              onModalClose={() => setShowConfirmationPopup(false)}
            >
              <div className="fs-14">
                <p>PAYMENT:</p>
                <div className="d-flex justify-content-between">
                  <span>Premium</span>
                  <strong>
                    {formatCurrency(totalInvoice + Number(riderAmount))}
                  </strong>
                </div>
                <div className="d-flex justify-content-between mt-2">
                  <span>Payment Surcharge</span>
                  <span>{formatCurrency(checkoutPgCharge)}</span>
                </div>
                <div className="d-flex justify-content-between">
                  <span>GST on Surcharge</span>
                  <span>{formatCurrency(gstcheckoutPgCharge)}</span>
                </div>
                <hr />
                <div className="d-flex justify-content-between">
                  <span>Total</span>
                  <strong>{formatCurrency(checkoutInvTotal)}</strong>
                </div>
              </div>
              <div className="d-flex gap-2 justify-content-end mt-3">
                <AppButton
                  variant="outlined"
                  btnText="Cancel"
                  onClick={() => setShowConfirmationPopup(false)}
                />
                <AppButton
                  variant="primary"
                  btnText="Confirm & Pay"
                  onClick={async () => {
                    setShowConfirmationPopup(false);
                    await handleContinueBooking();
                  }}
                />
              </div>
            </AppModal>
          )}

          {showBenifitsPopup && (
            <AppModal
              modalTitle="Plan benefits"
              showFooter={false}
              showCloseButton
              className="sales-rep-details fs-14"
              onModalClose={() => setShowBenifitsPopup(false)}
            >
              {planBenifits.length > 0 ? (
                <div className="d-flex flex-column">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Plan Benifit</th>
                        <th>Amount</th>
                        <th>Deductable</th>
                      </tr>
                    </thead>
                    <tbody>
                      {planBenifits.map((benifit, index) => (
                        <tr key={index}>
                          <td>{benifit.benefitname}</td>
                          <td>{benifit.benefitvalue}</td>
                          <td>{benifit.deductable}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div>No Benifits Found</div>
              )}
            </AppModal>
          )}
          {showEmailModal && (
            <AppModal
              modalTitle="Share Plan Details"
              showFooter={false}
              showCloseButton
              className="sales-rep-details fs-14"
              onModalClose={handleCloseEmailModal}
            >
              <div className="d-flex gap-2 align-items-center">
                <div className="flex-1">
                  <AppTextInput
                    label="Email"
                    value={emailToSent}
                    onChange={(e) => setEmailToSent(e.target.value)}
                  />
                </div>
                <AppButton btnText="Send Email" onClick={handleSendEmail} />
              </div>
            </AppModal>
          )}
        </>
      )}
    </div>
  );
}

export default InsurancePage;
